import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		// без анимации
		window.scrollTo(0, 0);

		// если хочешь плавно – можно так:
		// window.scrollTo({ top: 0, behavior: "smooth" });
	}, [pathname]);

	return null;
}
